import Application from "../Application";
import Area, { IArea } from "./Area";
import { IRouter } from "../runtime/Router";
import HomePage from "../ui/pages/main/BackOfficeHomePage";
import EmptyPage from "../ui/pages/EmptyPage";
import ShowHomeInteractor from "../interactor/main/ShowHomeInteractor";
import { Layouts, RoleConstants } from "../common/Constants";
import RegisteredApplicantsPage from "../ui/pages/applicants/RegisteredApplicantsPage";
import ShowRegisteredApplicantsInteractor from "../interactor/applicants/ShowRegisteredApplicantsInteractor";

export default class HomeArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/home",
        page: this.createPage({
          Page: HomePage,
          action: this.showHomePage.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_ADMIN,
            RoleConstants.MIK_BO.MIK_OSOBLJE,
            RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
          ]
        }
      },
      {
        path: "/",
        page: this.createPage({
          Page: RegisteredApplicantsPage,
          action: this.showRegisteredApplicantsPage.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_ADMIN,
            RoleConstants.MIK_BO.MIK_OSOBLJE,
            RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
          ]
        }
      },
      {
        path: "/error",
        page: this.createPage({
          Page: EmptyPage,
          action: () => {}
        }),
        options: {
          secure: false,
          initialProps: {
            title: "Error",
            text: "page not found."
          },
          layout: Layouts.BASE
        }
      },
      {
        path: "/forbidden",
        page: this.createPage({
          Page: EmptyPage,
          action: () => {}
        }),
        options: {
          secure: false,
          initialProps: {
            title: "Forbidden",
            text: "You are not allowed to access this page."
          },
          layout: Layouts.BASE
        }
      }
    );
  }

  public showHomePage() {
    return this.application.container
      .resolve<ShowHomeInteractor>("showHome")
      .execute();
  }

  public showRegisteredApplicantsPage() {
    return this.application.container
      .resolve<ShowRegisteredApplicantsInteractor>("showRegisteredApplicants")
      .execute();
  }
}
